(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zel-refresh-product"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-refresh-offer]').forEach(function(link){var destination=new URL(link.href);var current=new URL(location.href);current.searchParams.forEach(function(value,key){if(key.startsWith('utm_')||key==='fbclid'||key==='preview_theme_id'){destination.searchParams.set(key,value);}});link.href=destination.toString();});
  } catch(e) { console.error(e); }
})();

})();
